"use client";

/**
 * UixI18nProvider — Kliens oldali i18n Provider wrapper
 *
 * A Next.js App Router-ben a layout Server Component lehet,
 * de a Context providernek kliens komponensnek kell lennie.
 * Ez a wrapper oldja meg ezt a határt.
 */

import React, { useState } from "react";
import type { ReactNode } from "react";
import { UixTranslationProvider, type UixLocale } from "../core/useUixTranslation";

interface UixI18nProviderProps {
    initialLocale: UixLocale;
    initialCurrency: string;
    initialDict: Record<string, unknown>;
    children: ReactNode;
}

export function UixI18nProvider({
    initialLocale,
    initialCurrency,
    initialDict,
    children,
}: UixI18nProviderProps) {
    const [locale, setLocale] = useState<UixLocale>(initialLocale);
    const [currency] = useState<string>(initialCurrency);
    const [dict] = useState<Record<string, unknown>>(initialDict);

    return (
        <UixTranslationProvider locale={locale} currency={currency} dict={dict} setLocale={setLocale}>
            {children}
        </UixTranslationProvider>
    );
}
